import { render, staticRenderFns } from "./SearchTagInputShow.vue?vue&type=template&id=7a6984fa&scoped=true"
import script from "./SearchTagInputShow.vue?vue&type=script&lang=js"
export * from "./SearchTagInputShow.vue?vue&type=script&lang=js"
import style0 from "./SearchTagInputShow.vue?vue&type=style&index=0&id=7a6984fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6984fa",
  null
  
)

export default component.exports